import CustomerStoryVertical from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryVertical"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getLink} from "@hooks/PagesData/getLink"
import {
	AdvancedSideAssetModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomersSection.module.scss"

type Props = {
	data: CustomerStoryModuleType[]
	body?: AdvancedSideAssetModuleType
}

const CustomersSection = (props: Props) => {
	return (
		<section style={{backgroundColor: "#F8FAFE"}}>
			<ContainerWrapper>
				<Separator size={128} />

				<Separator withoutMeasure>
					<Typography
						content={
							props.body
								? props.body?.sectionTitle
								: "Customer stories"
						}
						variant={Variant.SectionTitle}
					/>
					<Typography
						content={
							props.body
								? props.body.sectionSubtitle
								: "Learn how our customers are utilising videos in their daily work"
						}
						variant={Variant.SectionSubtitle}
					/>
				</Separator>
				{/* Stories Cards Part */}
				<Separator />
				<Separator
					className={styles.cardContainer}
					type={"padding"}
					withoutMeasure
				>
					{props.data.map(
						(element: CustomerStoryModuleType, index: number) => {
							if (index > 0 && index < 4) {
								return (
									<CustomerStoryVertical
										key={index}
										className={styles.cardBox}
										data={element}
										minimal
									/>
								)
							}

							return null
						},
					)}
				</Separator>
				<Separator />
				<ButtonContainer>
					<ButtonComponent
						buttonType={"secondary"}
						link={
							props.body
								? props.body.sectionBottomButtonLink
								: getLink("customerStories")
						}
						asLink
					>
						{props.body
							? props.body.sectionBottomButton
							: "More Customer Stories"}
					</ButtonComponent>
				</ButtonContainer>
				<Separator size={128} />
			</ContainerWrapper>
		</section>
	)
}

export default CustomersSection
